// Shared look for the Time Tracking pages. Colours come from the theme
// variables so the pages work in both the light and the dark theme.

export const field = { padding: '8px 10px', border: '1px solid var(--input-border, var(--border))', borderRadius: 6, fontSize: 14, background: 'var(--input-bg, var(--surface))', color: 'var(--text-main)' };
export const ghost = { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px', border: '1px solid var(--border)', borderRadius: 6, background: 'transparent', color: 'var(--text-main)', cursor: 'pointer', fontSize: 13, fontWeight: 500 };
export const primary = { padding: '8px 14px', fontSize: 14 };
export const muted = { color: 'var(--text-muted)', fontSize: 13 };
export const card = { padding: 20, marginBottom: 20 };
export const chip = { display: 'inline-flex', alignItems: 'center', gap: 4, border: '1px solid var(--border)', borderRadius: 16, padding: '3px 10px', fontSize: 13, color: 'var(--text-main)' };
export const rowBorder = '1px solid var(--border)';

const pad = (n) => String(n).padStart(2, '0');
export const hm = (sec) => `${Math.floor((sec || 0) / 3600)}h ${pad(Math.floor(((sec || 0) % 3600) / 60))}m`;
export const errorText = (e, fallback) => e.response?.data?.error || fallback;
export const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

// 'YYYY-MM-DD' helpers (calendar dates, no time zone involved).
export const addDays = (key, n) => {
    const d = new Date(`${key}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
};
export const dayLabel = (key, opts = { weekday: 'long', day: 'numeric', month: 'short' }) =>
    new Date(`${key}T00:00:00Z`).toLocaleDateString(undefined, { ...opts, timeZone: 'UTC' });
export const weekLabel = (weekStart) =>
    `${dayLabel(weekStart, { day: 'numeric', month: 'short' })} – ${dayLabel(addDays(weekStart, 6), { day: 'numeric', month: 'short', year: 'numeric' })}`;

// Entries grouped by work date, newest day first, with a total per day.
export const groupByDay = (entries) => {
    const days = {};
    entries.forEach(e => { const k = e.workDate.slice(0, 10); (days[k] = days[k] || []).push(e); });
    return Object.keys(days).sort().reverse().map(date => ({ date, entries: days[date], totalSec: days[date].reduce((s, e) => s + e.durationSec, 0) }));
};
